<template lang="pug">
div
  v-row(v-if="chargers && chargers.length > 0")
    v-col(cols=12 lg=5 v-if="(mobile && !showMap) || !mobile" v-bind:class="{scrolling:!mobile}")
      v-tabs(v-model="tab")
          v-tab 1. Car
          v-tab 2. Trips
          v-tab(:disabled="routeData == null") 3. Itinerary
      v-tabs-items(v-model="tab" class="full-height-tab")
          v-tab-item
              DriverProfile(:models="modelData" :cars="carData" @updateSelected="updateCar" :driver="driver" @updateTrip="calculateTrip" :selectedCar="selectedCar"    @next="nextTab(1)")
          v-tab-item
              PlanTrip(class="ma-1 pa-2" ":trips"="trips" @tripUpdated="calculateTrip" @next="nextTab(2)" @selectionChanged="selectionChanged" :selectedTrip="selectedTrip")
          v-tab-item
              RoutePlanResults(:stops="routeData" :tripSummary="tripSummary" :trip="selectedTrip" :driver="driver", :summary="this.routeData ? this.routeData.route_summary : {}" :car="selectedCar" :chargers="chargers" @toggleAllChargers="toggleAllChargers" :radarAddress="radarAddress" @addressUpdated="updateRadarMarkers")
    v-col(cols=12 lg=7)
      div.ma-2
        ActionBar(v-if="!mobile")
      PlannerMap(v-if="(mobile && showMap) || !mobile" :routeData="routeData" :car="selectedCar" :chargers="chargers" :radarMarkers="chargerMarkers" :trip="selectedTrip" :allChargers="allChargers" :splat="rangeSplat" :homeAddress="radarAddress" :settings="settings" @centerRadar="clickedLocation"  @clickedLocation="clickedLocation" ref="myMap")   
      v-btn(block @click="hideMap" fixed bottom v-if="mobile") 
        span(v-if="showMap") Hide Map
        span(v-if="!showMap") Show Map
    v-snackbar(v-model="snackbar" :timeout="-1") {{ messageText }}
      v-btn(v-if="!waiting" color="pink" text @click="snackbar = false") Close
      v-progress-circular(v-if="waiting" color="pink" indeterminate)
  v-row(v-else)
    img#loading(src="https://powersell.appstack.me/icons/loading.svg" alt="Loading..." style="position: absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:400px;height:249px;")
</template>

<script>
import PlannerMap from "../components/PlannerMap.vue";
import EVNav from "../services/api/EVNav.js";
import PowerTrip from "../services/api/PowerTrip.js";
import PlanTrip from "../components/PlanTrip.vue";
import DriverProfile from "../components/DriverProfile.vue";
import RoutePlanResults from "../components/RoutePlanResults.vue";
import ActionBar from "../components/ActionBar.vue";
import { headerBus } from "../main";
import _ from "lodash";
import Vue from "vue";
export default {
  data() {
    return {
      tab: null,
      mapVisible: false,
      routeData: null,
      settings: this.$dealer.user_settings,
      chargers: null,
      trips: Vue.prototype.$trips,
      selectedTrip: null,
      selectedCar: null,
      carYear: 2020,
      allChargers: false,
      radarChargers: [],
      radarAddress: { Address: null },
      driver: {
        aa: 50,
        sa: 0,
        soh: 100,
        battery: 100,
        passengers: 1,
        batteryMin: 20,
        batteryMax: 95,
        extraWeight: 0,
      },
      snackbar: false,
      messageText: "",
      waiting: true,
      tripSummary: "",
    };
  },
  created() {
    headerBus.$on("toggleMap", () => {
      this.mapVisible = !this.mapVisible;
    });
  },
  computed: {
    paths() {
      let paths = [];
      if (this.$refs.myMap && this.chargerMarkers && this.$refs.myMap.$refs.markers) {
        for (let i = 0; i < this.chargerMarkers.length; i++) {
          let marker = this.$refs.myMap.$refs.markers[i].mapObject;
          let r = this.$refs.myMap.$refs.radarCluster.mapObject.getVisibleParent(marker);
          if (r) {
            if (r._leaflet_id == marker._leaflet_id && paths.length < 20) {
              let m = this.chargerMarkers[i];

              paths.push({ id: m.ID, path: m.Path, EnergyPercent: m.EnergyPercent });
            }
          }
        }
      }
      return paths;
    },
    rangeSplat() {
      var points = this.chargerMarkers.map((e) => [
        parseFloat(e.LatLng.lat),
        parseFloat(e.LatLng.lng),
      ]);
      console.log("Convex Hull", this.convexHull(points));
      return this.convexHull(points);
    },
    mobile() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
        case "sm":
        case "md":
          return true;
        default:
          return false;
      }
    },
    showMap() {
      if (this.$vuetify.breakpoint.name == "lg") {
        return true;
      }
      return this.mapVisible;
    },
    chargerMarkers: function () {
      if (this.radarAddress.Address == null) {
        return [];
      }

      let markers = [];
      let src = {
        lat: this.radarAddress.Address.geometry.coordinates[1],
        lng: this.radarAddress.Address.geometry.coordinates[0],
      };
      if (this.radarChargers && this.chargers) {
        for (let i = 0; i < this.chargers.length; i++) {
          let c = this.chargers[i];
          let rc = this.radarChargers.find((e) => e.id == c.ID);
          if (rc) {
            let m = {};
            m.Name = c.Title;
            m.ID = c.ID;
            m.Current = c.Current;
            m.KwRated = c.KwRated;
            m.Charger = c;
            let dst = { lat: rc.location[1], lng: rc.location[0] };
            m.EnergyPercent =
              (rc.energy_used / parseFloat(this.selectedCar.BatterySize)) * 100;
            m.Path = [
              { lng: src.lng, lat: src.lat },
              { lng: dst.lng, lat: dst.lat },
            ];
            m.LatLng = { lat: c.Latitude, lng: c.Longitude };
            markers.push(m);
          }
        }
      }
      return markers;
    },
  },
  methods: {
    hideMap() {
      headerBus.$emit("toggleMap");
    },
    clickedLocation(location) {
      this.radarChargers = [];
      let latlng = location.latlng || location.LatLng;
      this.radarAddress.Address = {
        Address: "",
        geometry: {
          coordinates: [latlng.lng, latlng.lat],
        },
      };
      this.$refs.myMap.centerMap(latlng);
      EVNav.reverseGeocode(latlng).then((data) => {
        this.radarAddress.Address = this.convertAddress(data);
        this.updateRadarMarkers();
      });
    },
    toggleAllChargers(on) {
      this.allChargers = on;
    },
    selectionChanged(trip) {
      if (this.selectedTrip == null || trip.id != this.selectedTrip.id) {
        this.selectedTrip = trip;
        this.calculateTrip();
      }
    },
    calculateTrip() {
      if (this.radarAddress.Address == null && this.selectedTrip != null) {
        this.radarAddress = _.clone(this.selectedTrip.fromAddress);
      }
      this.updateRadarMarkers();
      if (this.selectedTrip) {
        var $this = this;
        if (
          this.selectedTrip.fromAddress != null &&
          this.selectedTrip.fromAddress.Address != null &&
          this.selectedTrip.toAddress != null &&
          this.selectedTrip.toAddress.Address != null &&
          this.selectedCar != null
        ) {
          this.showMessage("Planning route for " + this.selectedTrip.title + "...", true);
          this.routeData = null;
          EVNav.planRoute(this.selectedTrip, this.selectedCar, this.driver).then(
            (response) => {
              this.routeData = response;
              if (this.routeData.points == undefined) {
                this.showMessage("We can't find a suitable route for these settings.");
              } else {
                let time = this.niceDuration(this.routeData.route_summary.duration);

                let cost =
                  "$" + this.formatPrice(this.routeData.route_summary.charging_cost);
                let distance = Math.round(this.routeData.route_summary.distance / 1000);

                this.tripSummary =
                  this.selectedTrip.title +
                  " is " +
                  distance +
                  "kms will take " +
                  time +
                  " and cost around " +
                  cost;
                $this.snackbar = false;
              }
            }
          );
        }
      }
    },
    updateCar(car) {
      this.selectedCar = car;
      this.calculateTrip();
    },
    showMessage(message, waiting = false) {
      this.messageText = message;
      this.waiting = waiting;
      this.snackbar = true;
    },
    nextTab(index) {
      this.tab = index;
    },
    async updateRadarMarkers() {
      if (this.radarAddress.Address && this.radarAddress.Address.geometry) {
        let homeLocation = {
          lat: parseFloat(this.radarAddress.Address.geometry.coordinates[1]),
          lng: parseFloat(this.radarAddress.Address.geometry.coordinates[0]),
        };
        EVNav.chargerRadar(homeLocation, this.selectedCar, this.driver).then(
          (response) => (this.radarChargers = response.data.chargers)
        );
      } else {
        this.radarChargers = [];
      }
    },
  },
  mounted: function () {
    if (localStorage.getItem("driver")) {
      this.driver = JSON.parse(localStorage.getItem("driver"));
    }
    if (this.trips.length > 0) {
      this.selectedTrip = this.trips[0];
      this.tab = 1;
    }
    if (localStorage.getItem("car")) {
      this.selectedCar = JSON.parse(localStorage.getItem("car"));
      this.calculateTrip();
    } else {
      this.selectedCar = this.cars[0];
      console.log("THIS CAR", this.selectedCar);
    }
    this.radarAddress = this.selectedTrip
      ? _.clone(this.selectedTrip.fromAddress)
      : this.radarAddress;
    //
    PowerTrip.getChargingStations().then((stations) => {
      this.chargers = stations;
      this.updateRadarMarkers();
    });
  },
  components: {
    PlannerMap,
    PlanTrip,
    DriverProfile,
    RoutePlanResults,
    ActionBar,
  },
  watch: {
    selectedCar(newCar) {
      const parsed = JSON.stringify(newCar);
      localStorage.setItem("car", parsed);
    },
    driver: {
      handler: function (newDriver) {
        const parsed = JSON.stringify(newDriver);
        localStorage.setItem("driver", parsed);
      },
      deep: true,
    },
    trips: {
      handler: function (newTrips) {
        const parsed = JSON.stringify(newTrips);
        localStorage.setItem("trips", parsed);
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.scrolling .v-tabs-items.full-height-tab .v-window-item {
  height: calc(100vh - 78px);
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
